<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <transition name="el-fade-in-linear" v-if="this.teacherID">
      <Jianli :tid="teacherID" :button="button" :cid="cid"
        style="width:3.75rem;height:auto;position:absolute;box-shadow: 0 0 .1042rem rgba(0, 0, 0, .25);padding: .1042rem .1042rem .3125rem .2083rem; z-index: 999;background-color: #fff;top: .9813rem;">
      </Jianli>
    </transition>

    <img v-if="this.teacherID" src="../../assets/close.png" @click="teacherID = ''"
      style=" width: .0521rem;height: .0521rem;position:absolute; top: 1.1475rem;left: 7.2688rem; z-index: 1000;" alt="">
    <!-- 正文 -->
    <div id="toudi">

      <!-- <div class="line"></div> -->
      <div class="bigbox" v-for="item in bigtotal  ">
        <div class="boxtitle">
          <span><img src="../../assets/Stoudititle.png" alt="">{{ item.itemId ? itemlist[item.itemId] : '预约教师' }}</span>
          <div class="time"><img src="../../assets/Stouditime.png" alt="">需求发布时间：{{ item.time }}</div>
        </div>
        <div v-if="item.parentVerifiedTeacherVOList !== null && item.parentVerifiedTeacherVOList.length == 0">
          <el-empty description="暂时无人投递"></el-empty>
        </div>
        <div class="smallbox" v-for="ele in item.parentVerifiedTeacherVOList" v-else>
          <div class="head"><img :src="'https://www.cdjjwang.com/' + ele.avatar" alt=""></div>
          <div class="info">
            <div class="stitle">
              <div class="name"></div>
              <div class="school">{{ teachertype[ele.isCollegeStudent] }}</div>
              <div class="school">{{ ele.university }}</div>
              <div class="timer"><img src="../../assets/indexFTboxtimer.png" alt="">累计授课{{ ele.classHours }}h</div>
            </div>
            <div class="txt">{{ ele.teachingExperience }}</div>
          </div>
          <div class="options">
            <span @click="jieshou(ele.cid)" v-if="ele.zhudong">接受</span>
            <span @click="jujue(ele.cid)" v-if="ele.zhudong">拒绝</span>
            <span @click="look(ele)">查看简历</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Jianli from '../layout/Slookteacherjianli.vue'
export default {
  components: {
    Jianli
  },
  data() {
    return {
      teacherID: '',
      button: [true, true],
      total: [],
      cid: '',
      gradelist: ['小学', '初中', '高中'],
      teachertype: ['专职教师', '在读本科生', '在读研究生'],
      bigtotal: [],
      show: false,
      itemlist: {
        10: '小学全科',
        11: '小学语文',
        12: '小学奥数',
        13: '小学数学',
        14: '小学英语',
        15: '小学作业辅导',
        20: '初中全科',
        21: '初中语文',
        22: '初中英语',
        23: '初中数学',
        24: '初中物理',
        25: '初中化学',
        30: '高中数学',
        31: '高中语文',
        32: '高中英语',
        33: '高中物理',
        34: '高中化学',
        35: '高中生物',
        36: '高中历史',
        37: '高中政治',
        38: '高中地理',
        40: '法语',
        41: '德语',
        42: '西班牙语',
        43: '日语',
        44: '葡萄牙语',
        45: '韩语',
        50: '音乐',
        51: '美术',
        52: '舞蹈',
        53: '体育',
        54: '体育',
        60: '其他',
      }
      // 10：小学全科11：小学语文12：小学奥数13：小学数学14：小学英语15：小学作业辅导20：初中全科21：初中语文22：初中英语23：初中数学24：初中物理25：初中化学30：高中数学31：高中语文32：高中英语33：高中物理34：高中化学35：高中生物36：高中历史37：高中政治38：高中地理40：法语41：德语42：西班牙语43：日语44：葡萄牙语45：韩语50：音乐51：美术52：舞蹈53：体育54：体育60：其他70：计算机
    }
  },
  created() {
    this.$http.get('/Api/Parent/Demands', {
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      },
      params: {
        pageNumber: 1,
        pageSize: 999,
        type: 3,
      }
    }).then(res => {
      console.log(res);
      this.bigtotal = res.data.data.records
      this.bigtotal.forEach(item => {
        let isoString = item.time;
        let date = new Date(isoString);
        let localString = date.toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
        localString = localString.replace(/\//g, '年').replace(/ /, '月').replace(/ /, '日');
        item.time = localString
        if (item.parentVerifiedTeacherVOList == null) {
          item.parentVerifiedTeacherVO.zhudong = false
          item.parentVerifiedTeacherVOList = [item.parentVerifiedTeacherVO]
          console.log(item.parentVerifiedTeacherVOList);
        }
      })
    })

  },
  methods: {
    jieshou(cid) {
      this.$http.put('/Api/Parent/Contract/' + cid + '/Apply', {}, {
        headers: {
          'Authorization': localStorage.getItem('Authorization')
        }

      }).then(res => {
        console.log(res);
      })
    },
    jujue(cid) {
      this.$http.put('/Api/Parent/Contract/' + cid + '/Refuse', {}, {
        headers: {
          'Authorization': localStorage.getItem('Authorization')
        }
      }).then(res => {
        console.log(res);
      })
    },
    look(a) {
      this.teacherID = a.tid;
      this.cid = a.cid;
      if (!a.zhudong) {
        this.button = [false, false]
      }
      else {
        this.button = [true, true]
      }
    }
  }




}
</script>

<style scoped>
#toudi .title {
  width: 406px;
  height: 38px;
  font-family: 苹方;
  font-size: 36px;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: left;
}

#toudi .line {
  /* 一级标签页/Padding (style) */
  width: 800px;
  height: 2px;
  background: rgb(228, 231, 237);
  margin-top: 18px;
}

#toudi .bigbox {
  margin-top: 33px;
}

#toudi .boxtitle {
  display: flex;
}

#toudi .boxtitle span {
  /* BG */
  width: auto;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius:
    3px;
  /* 默认标签 */
  color: rgba(255, 255, 255, 0.9);
  font-family: 思源黑体;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: -1px;
  text-align: left;
  padding-left: 15px;
  padding-right: 15px;
  margin-right: 18px;
}

#toudi .boxtitle span img {
  margin-right: 9px;
  transform: translateY(5px);
}

#toudi .boxtitle .time {
  margin-top: 15px;
  /* 需求发布时间：2023年1月1日19：00 */
  height: 20px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.01px;
  text-align: center;
}

#toudi .boxtitle .time img {
  margin-right: 4px;
  transform: translateY(2px);
  width: 14px;
  height: 14px;
}

#toudi .bigbox .smallbox {
  /* 矩形 30 */
  width: 800px;
  height: 96px;
  background: rgb(255, 255, 255);
  box-shadow: 0px 0px 4px 5px rgba(0, 0, 0, 0.07);
  margin-top: 28px;
  display: flex;
}

#toudi .bigbox .smallbox .head img {
  width: 56px;
  height: 56px;
  border-radius: 100px;
  margin-top: 20px;
  margin-left: 27px;
}

#toudi .bigbox .smallbox .info {
  /* 组合 13 */
  width: 515px;
  height: 56px;
  margin-top: 20px;
  margin-left: 20px;
}

#toudi .bigbox .smallbox .info .stitle {
  display: flex;
}

#toudi .bigbox .smallbox .info .stitle .name {
  /* 张三 */
  height: 20px;
  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.01px;
  text-align: center;
}

#toudi .bigbox .smallbox .info .stitle .school {
  /* tag/default/default/dark/off (style) */
  background: rgb(207, 242, 240);
  border-radius: 2px;
  /* 在读本科生 */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.01px;
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
  margin-left: 15px;
}

#toudi .bigbox .smallbox .info .stitle .timer {
  /* tag/default/default/plain/off (style) */
  height: 24px;
  border: 1px solid rgb(1, 162, 153);
  border-radius: 2px;
  /* 累计授课200h */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01px;
  text-align: center;
  padding-right: 15px;
  margin-left: 10px;
  padding-left: 10px;
}

#toudi .bigbox .smallbox .info .stitle .timer img {
  width: 12px;
  height: 14px;
  margin-right: 3px;
  transform: translateY(2px);

}

#toudi .bigbox .smallbox .info .txt {
  /* 教学经历教学经历教学经历教学经历教学经历教学经历教学经历教学经历教学经历教学经 */
  width: 482px;
  height: 20px;
  color: rgb(96, 98, 102, .8);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.01px;
  text-align: left;
  overflow: hidden;
  margin-top: 14px;
}

#toudi .bigbox .smallbox .options {
  display: flex;
  height: 22px;
  margin-top: 56px;
}

#toudi .bigbox .smallbox .options span {
  /* 查看详情 */
  height: 22px;
  color: rgb(24, 144, 255);
  font-family: 黑体;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  margin-right: 13px;
  cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/studenttoudi.vue